(function () {
    'use strict';
    angular.module('finansApp.courseSorterController', []).controller('courseSorterController', courseSorterController);
    
    courseSorterController.$inject = ['courseService', 'courseSortService', '$filter', '$timeout', '$location'];


    function courseSorterController(courseService, courseSortService, $filter, $timeout, $location) {
        var vm = this;
        vm.state = courseSortService.state;
        vm.state.showFilter = false;


        vm.sortList = function() {

            courseSortService.sortCourses(courseService.state.coursesFiltered).then(function(arr){
                courseService.state.coursesFiltered = arr;
            })

            // Once we have the data, init the images with responsive
            $timeout(function() {
                novicell.responsiveImages.init();
            }, 0);
        }

        vm.setSorting = function(value) {
            vm.state.sortOrder = value;
            vm.state.showFilter = false;
            vm.sortList();

            courseSortService.setUrl()
        }

        function init() {
            getDataFromUrl();
        }

        function getDataFromUrl() {
           var params = $location.search();

            if(typeof (params['sort']) !== 'undefined' && params['sort']) {
                vm.state.sortOrder = params['sort'];
            }
        }

        
        init();


    }

})();